import React from 'react';
import { PhoneIcon, MessageSquareIcon } from 'lucide-react';
import { christmasContacts } from '../../data/christmasContacts';
import type { ChristmasContact } from '../../data/christmasContacts';
const iconBtn = 'flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white/10 text-[#EAD9A8] transition-colors hover:bg-olive hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage';
type ChristmasContactBarProps = {
  contacts?: ChristmasContact[];
  ariaLabel?: string;
};
export function ChristmasContactBar({
  contacts = christmasContacts,
  ariaLabel = 'Christmas lighting contacts'
}: ChristmasContactBarProps) {
  const single = contacts.length === 1;
  return <div className="bg-forest text-white" data-id="element-15" data-mp="7sg5b3p8uyka">
      <ul aria-label={ariaLabel} className={`mx-auto max-w-7xl gap-x-8 gap-y-2 px-5 py-2.5 sm:px-8 ${single ? 'flex justify-end' : 'grid grid-cols-1 sm:grid-cols-2 md:flex md:justify-end'}`} data-id="element-16" data-mp="7pbpta6bwgeb">
        {contacts.map(contact => <li key={contact.id} lang={contact.lang} className="flex items-center justify-between gap-3 md:justify-start" data-id="element-17" data-mp="3sxgawmlzt4mj">
            <span className="min-w-0 leading-tight" data-id="element-18" data-mp="1my1wkl3jb77">
              <span className="block text-[10px] font-bold uppercase tracking-[0.16em] text-sage-light" data-id="element-19" data-mp="5q47rr4ar0d5">
                {contact.heading} — {contact.name}
              </span>
              <a href={`tel:${contact.phoneE164}`} aria-label={contact.callAria} className="text-sm font-semibold text-white transition-colors hover:text-[#EAD9A8]" data-id="element-20" data-mp="fhid4fixiue7">
                {contact.phoneDisplay}
              </a>
            </span>
            <span className="flex items-center gap-1.5" data-id="element-21" data-mp="tgrv9kqp3ykt">
              <a href={`tel:${contact.phoneE164}`} aria-label={contact.callAria} title={contact.callLabel} className={iconBtn} data-id="element-22" data-mp="te5kzdcf74yw">
                <PhoneIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-23" data-mp="2v7bnks70wmqt" />
              </a>
              <a href={`sms:${contact.phoneE164}`} aria-label={contact.textAria} title={contact.textLabel} className={iconBtn} data-id="element-24" data-mp="2d4nfbnu6cza">
                <MessageSquareIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-25" data-mp="3tkpjtp8be7tk" />
              </a>
            </span>
          </li>)}
      </ul>
    </div>;
}